import React, { useState, useEffect } from "react";
import axiosInstance from "../utils/axios";
import PublicPageShell from "../components/PublicPageShell";

const CommunityInfo = () => {
  const [communityInfoHtml, setCommunityInfoHtml] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get("/api/community/community-info")
      .then((res) => setCommunityInfoHtml(res.data.communityInfo || ""))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading)
    return (
      <div className="flex h-screen justify-center items-center">
        <i
          className="pi pi-spin pi-spinner text-red-700"
          style={{ fontSize: "2rem" }}
        ></i>
      </div>
    );

  if (!communityInfoHtml) {
    return (
      <PublicPageShell className="text-[#003049] py-8">
        <p className="text-center text-gray-500">
          No community information available yet.
        </p>
      </PublicPageShell>
    );
  }

  return (
    <PublicPageShell className="text-[#003049] pt-0">
      <div
        className="community-info-content w-full bg-white rounded-lg border border-[#e5e7eb] shadow-md p-4 lg:p-6 prose prose-lg max-w-none text-[#003049]"
        dangerouslySetInnerHTML={{ __html: communityInfoHtml }}
      />
    </PublicPageShell>
  );
};

export default CommunityInfo;
